import React from 'react';

import SiteEmbed from '../UseCaseComponents/SiteEmbed';
import TextSection from '../UseCaseComponents/TextSection';

const SiteStarterLayout = ({ useCase }) => {
  const { site, text } = useCase.components;

  return (
    <div className="mt-8 w-full">
      {(text?.heading || text?.body) && (
        <TextSection
          heading={text?.heading}
          body={text?.body}
          className="mb-6 max-w-2xl"
        />
      )}

      <SiteEmbed
        url={site?.url}
        title={useCase.title}
        height={site?.height}
      />

      {site?.url && (
        <a
          href={site.url}
          target="_blank"
          rel="noreferrer"
          className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700 hover:text-primary-800"
        >
          Open in a new tab
          <span aria-hidden="true">&rarr;</span>
        </a>
      )}
    </div>
  );
};

export default SiteStarterLayout;
